<app-page-list [columns]="columns" [queryService]="service.query" [canInsert]="true" [crud]="service" [insertForm]="insertForm" insertFormTitle="utente" [isRowClickable]="false" [customClickFunction]="customClickFunction" [costumEditFunction]="true" [editFunction]="onEditFunction">
    <div insert-form class=" flex flex-column  gap-2" >
          <div class="field">
            <app-input-text [form]="insertForm" name="username" label="username"></app-input-text>
          </div>
          <div class="field">
            <app-input-text [form]="insertForm" name="email" label="email"></app-input-text>
          </div>
          <div class="field">
            <app-input-password [form]="insertForm" name="password" label="password"></app-input-password>
          </div>
          <div class="field">
            <app-input-password [form]="insertForm" name="passwordMatch" label="Conferma Password"></app-input-password>
          </div>
    </div>
  </app-page-list>
  